module.exports = __webpack_public_path__ + "img/machine-example.d5291061.jpg";